module.exports = __webpack_public_path__ + "static/media/img-card-four.5daefcb1.jpg";